import {api} from '@/http'

// 拆迁列表
const getCQList = (data, callback, back) => {
  api('/api/CQ_WP/List', 'post', data, callback, back)
}

// 拆迁添加
const cqAdd = (data, callback, back) => {
  api('/api/CQ_WP/Insert', 'post', data, callback, back)
}

// 拆迁删除
const cqDel = (id, callback, back) => {
  api('/api/CQ_WP/Delete', 'post', {Id: id}, callback, back)
}

// 拆迁详情
const cqDetail = (id, callback, back) => {
  api('/api/CQ_WP/Detail', 'post', {Id: id}, callback, back)
}

// 拆迁列表--负责人
const getCQListFZ = (data, callback, back) => {
  api('/api/CQ_WP/List_FZ', 'post', data, callback, back)
}

// 委派单测算--列表
const getMeasureUserList = (data, callback, back) => {
  api('/api/CQ_WP/List_User', 'post', data, callback, back)
}

// 委派单测算--上传提交
const csUploadSave = (data, callback, back) => {
  api('/api/CQ_CS/Insert', 'post', data, callback, back)
}

// 最新测算--条件
const getCQStage = (data, callback, back) => {
  api('/api/CQ_CS/StageNums', 'post', data, callback, back)
}

// 最新测算--列表
const getMeasureNewList = (data, callback, back) => {
  api('/api/CQ_CS/List', 'post', data, callback, back)
}

// 最新测算--删除
const csDel = (ids, callback, back) => {
  api('/api/CQ_CS/Delete', 'post', JSON.stringify(ids), callback, back)
}

// 最新测算--详情
const csDetail = (data, callback, back) => {
  api('/api/CQ_CS/Detail', 'post', data, callback, back)
}

// 测算报告上传后显示
const cqBaoGaoShow = (data, callback, back) => {
  api('/api/CQ_CS/Import', 'post', data, callback, back)
}

// 测算-保存
const cqBaoGaoSave = (data, callback, back) => {
  api('/api/CQ_CS/Save', 'post', data, callback, back)
}

// 测算-保存反馈意见
const cqBaoGaoSaveMsg = (data, callback, back) => {
  api('/api/CQ_CS/SaveMsg', 'post', data, callback, back)
}

// 测算-保存反馈意见
const csExamineMsg = (data, callback, back) => {
  api('/api/CQ_CS/ExamineMsg', 'post', data, callback, back)
}

// 测算-反馈
const csNoExamine = (data, callback, back) => {
  api('/api/CQ_CS/NoExamine', 'post', data, callback, back)
}

// 测算-通过
const csExamine = (data, callback, back) => {
  api('/api/CQ_CS/Examine', 'post', data, callback, back)
}

// 测算-归档
const csGD = (ids, callback, back) => {
  api('/api/CQ_CS/SubmitGD', 'post', JSON.stringify(ids), callback, back)
}

// 项目收费--列表
const getCQChargeList = (data, callback, back) => {
  api('/api/Charge/List_CQWP', 'post', data, callback, back)
}

// 项目收费--创建收费单
const addCQCharge = (data, callback, back) => {
  api('/api/Charge/Insert', 'post', data, callback, back)
}

// 项目收费--收费单管理列表
const getCQChargeManageList = (data, callback, back) => {
  api('/api/Charge/List', 'post', data, callback, back)
}

// 项目收费--收费单管理删除
const delCQChargeManage = (id, callback, back) => {
  api('/api/Charge/Delete', 'post', {Id: id}, callback, back)
}

// 项目收费--收费单管理详情
const detailCQChargeManage = (id, callback, back) => {
  api('/api/Charge/ChargeDetail', 'post', {Id: id}, callback, back)
}

// 项目收费--收费单管理记录
const getChargeManageRecordList = (data, callback, back) => {
  api('/api/Charge/RecordList', 'post', data, callback, back)
}

// 项目收费--收费单管理记录添加
const addChargeManageRecord = (data, callback, back) => {
  api('/api/Charge/RecordInsert', 'post', data, callback, back)
}

// 项目收费--收费单管理记录删除
const delChargeManageRecord = (id, callback, back) => {
  api('/api/Charge/RecordDelete', 'post', {Id: id}, callback, back)
}

// 项目收费--收费单管理记录完成
const completeChargeManageRecord = (id, callback, back) => {
  api('/api/Charge/Complete', 'post', {Id: id}, callback, back)
}

// 拆迁绩效
const getCQJXList = (data, callback, back) => {
  api('/api/JX_CQ/CQList', 'post', data, callback, back)
}

// 拆迁绩效-天数查询
const getCQJXDays = (data, callback, back) => {
  api('/api/JX_CQ/Days', 'post', data, callback, back)
}

// 拆迁绩效-记录
const getCQJXRecordList = (data, callback, back) => {
  api('/api/JX_CQ/RecordList', 'post', data, callback, back)
}

// 拆迁绩效-强度保存
const saveCQJXRecord = (data, callback, back) => {
  api('/api/JX_CQ/JXSave', 'post', data, callback, back)
}

// 拆迁绩效-提醒
const remindCQJXRecord = (data, callback, back) => {
  api('/api/JX_CQ/Remind', 'post', data, callback, back)
}

// 拆迁绩效-人员列表
const getCQJXUserList = (data, callback, back) => {
  api('/api/JX_CQ/UserList', 'post', data, callback, back)
}

// 拆迁绩效-人员月度绩效
const getCQJXUserAll = (data, callback, back) => {
  api('/api/JX_CQ/UserJXList', 'post', data, callback, back)
}

// 拆迁绩效-人员月度绩效统计
const getCQJXTotalList = (data, callback, back) => {
  api('/api/JX_CQ/JXTotalList', 'post', data, callback, back)
}

// 拆迁绩效设置
const getCQJXSetList = (data, callback, back) => {
  api('/api/JX_Setting/List', 'post', data, callback, back)
}

// 拆迁绩效添加
const addCQJXSet = (data, callback, back) => {
  api('/api/JX_Setting/Insert', 'post', data, callback, back)
}

// 拆迁绩效修改
const setSingle = (data, callback, back) => {
  api('/api/JX_Setting/SetSingle', 'post', data, callback, back)
}

// 拆迁项目个人绩效
const getMyCQJX = (data, callback, back) => {
  api('/api/JX_CQ/JX_My', 'post', data, callback, back)
}

// 拆迁绩效删除
const delCQJXSet = (id, callback, back) => {
  api('/api/JX_Setting/Delete', 'post', {Id: id}, callback, back)
}

// 拆迁绩效上报
const cqJXExamine = (ids, callback, back) => {
  api('/api/JX_CQ/Examine', 'post', JSON.stringify(ids), callback, back)
}

// 拆迁绩效上报
const sbCQJX = (data, callback, back) => {
  api('/api/JX_CQ/JX_CQSB', 'post', data, callback, back)
}

// 拆迁绩效-天数查询
const getCQJXDays1 = (data, callback, back) => {
  api('/api/JX_CQ/Days1', 'post', data, callback, back)
}
// 拆迁绩效重填
const cqJXNoExamine = (ids, callback, back) => {
  api('/api/JX_CQ/NoExamine', 'post', JSON.stringify(ids), callback, back)
}

export default {
  getCQStage,
  getCQList,
  cqAdd,
  cqDel,
  cqDetail,
  getCQListFZ,
  getMeasureUserList,
  csUploadSave,
  getMeasureNewList,
  csDel,
  csDetail,
  cqBaoGaoShow,
  cqBaoGaoSave,
  cqBaoGaoSaveMsg,
  csExamineMsg,
  csNoExamine,
  csExamine,
  csGD,
  getCQChargeList,
  addCQCharge,
  getCQChargeManageList,
  delCQChargeManage,
  detailCQChargeManage,
  getChargeManageRecordList,
  addChargeManageRecord,
  delChargeManageRecord,
  completeChargeManageRecord,
  getCQJXList,
  getCQJXDays,
  getCQJXDays1,
  getCQJXRecordList,
  saveCQJXRecord,
  remindCQJXRecord,
  getCQJXUserList,
  getCQJXUserAll,
  getCQJXTotalList,
  getCQJXSetList,
  addCQJXSet,
  delCQJXSet,
  cqJXExamine,
  sbCQJX,
  cqJXNoExamine,
  setSingle,
  getMyCQJX
}



// WEBPACK FOOTER //
// ./src/api/cq/index.js